import { Component, Input } from '@angular/core';
import {
  CupomDescontoTipoDesconto,
  ReurbModalidade,
  TabelaPrecoDetalhesDto,
  TabelaPrecoParcela,
  TabelaPrecoParcelaListaDto
} from '@usucampeao/lib-reurb-simplificado';
import { CadastroStateDto } from '../../domain';

@Component({
  selector: 'usucampeao-cadastro-resumo-pagamento',
  templateUrl: './cadastro-resumo-pagamento.component.html',
  styleUrls: ['./cadastro-resumo-pagamento.component.scss'],
})
export class CadastroResumoPagamentoComponent {
  @Input() cadastro: CadastroStateDto;
  @Input() superSocialSelecionado = false;
  @Input() entradaParcelasQuantidade: number;
  @Input() totalParcelas?: TabelaPrecoParcela;
  @Input() tabelaPreco: Partial<TabelaPrecoDetalhesDto>[];
  @Input() semPadding = false;

  public get descontoNaEntrada(): boolean {
    return this.cadastro?.cupomDescontoTipo === CupomDescontoTipoDesconto.ENTRADA;
  }

  public get descontoNoServico(): boolean {
    return this.cadastro?.cupomDescontoTipo === CupomDescontoTipoDesconto.SERVICO;
  }

  public get valorTotal(): number {
    return this.pagamentoSelecionado?.valorTotal;
  }

  public get valorDesconto(): number {
    return this.pagamentoSelecionado?.valorDesconto;
  }

  public get pagamentoAVista(): boolean {
    return this.pagamentoSelecionado?.parcela === TabelaPrecoParcela.PARCELA_0;
  }

  public get valorEntrada(): number {
    const valorAto = this.pagamentoSelecionado?.valorAto;
    const entradaParcelasQuantidade = this.entradaParcelasQuantidade || this.cadastro.entradaParcelasQuantidade;
    return parseFloat((valorAto / entradaParcelasQuantidade).toFixed(2));
  }

  public get opcoesParcelamento(): TabelaPrecoParcelaListaDto[] {
    return this.tabelaPrecoSelecionada?.parcelas || [];
  }

  public get entradaParcelamentos(): number[] {
    return Array.from({ length: this.entradaParcelasQuantidade || this.cadastro.entradaParcelasQuantidade }, (_, i) => i + 1);
  }

  public get pagamentoSelecionado(): TabelaPrecoParcelaListaDto {
    return this.tabelaPrecoSelecionada?.parcelas?.find(parcela => +parcela.parcela === this.parcelaSelecionada);
  }

  private get parcelaSelecionada(): number {
    const totalParcelas = this.totalParcelas ? +this.totalParcelas : null;
    const cadastroTotalParcelasSelecionada = this.cadastro?.totalParcelasSelecionada ? +this.cadastro?.totalParcelasSelecionada : null;
    const cadastroTotalParcelas = this.cadastro?.totalParcelas ? +this.cadastro?.totalParcelas : null;
    return totalParcelas ?? cadastroTotalParcelasSelecionada ?? cadastroTotalParcelas;
  }

  public get tabelaPrecoSelecionada(): Partial<TabelaPrecoDetalhesDto> {
    if (!this.tabelaPreco) {
      return null;
    }

    const possuiAverbacao = this.cadastro?.averbacaoSelecionada ?? this.cadastro?.averbacao ?? false;
    const tabelaPrecoSelecionada = this.tabelaPreco
      .find((item) => {
        if (this.superSocialSelecionado || this.cadastro.superSocial) {
          return item.modalidade === ReurbModalidade.SUPER_SOCIAL;
        }

        return item.modalidade === this.cadastro.reurbModalidade && (possuiAverbacao ? item.averbacao : !item.averbacao);
      });
    return tabelaPrecoSelecionada ? tabelaPrecoSelecionada : this.tabelaPreco[0];
  }
}
